import {
  RECEIVE_FIELDS,
  RECEIVE_FIELDS_FAILURE,
  RECEIVE_FIELDS_MULTI_OPERATIONS,
  RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
} from '../constants/actionTypes';

export function receiveFields(payload) {
  return {
    type: RECEIVE_FIELDS,
    payload,
  };
}

export function fieldsFailure() {
  return {
    type: RECEIVE_FIELDS_FAILURE,
  };
}

export function receiveFieldsMultiOperations(payload) {
  return {
    type: RECEIVE_FIELDS_MULTI_OPERATIONS,
    payload,
  };
}

export function fieldsFailureMultiOperations() {
  return {
    type: RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
  };
}
